import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from 'react-redux';
import { Info } from '../../../../../../assets/icons';
import { IReducer } from '../../../../../../redux/configureStore';
import { IClientsData } from '../../../../../../redux/duck/legado/clientsApp/interface/reduxInterface';
import Frame from '../../../../../../shared/components/Frame';
import {
  defineAccountType,
  setPartner,
} from '../../../../../../utils/businessRule';
import { capitalize, cpfCnpjMask } from '../../../../../../utils/masks';
import BankInfoModal from './components/BankInfoModal';
import Button from './components/Button';
import ExportCsv from './components/ExportCsv';
import ExportPdf from './components/ExportPdf';
import PaginationComponent from './components/Pagination';
import Subtitle from './components/Subtitle';
import TableComponent from './components/TableComponent';
import Text from './components/Text';
import Wrapper from './components/Wrapper';

function ClientsTableList() {
  const clientsDataState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.clientsList
  );

  const clientsState = useSelector((reducer: IReducer) => reducer.clientsApp);

  // Partner identificator: start
  const partnerListState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );
  // Partner identificator: end

  // If partner logged don't show partner column: start
  const profileState = useSelector((reducer: IReducer) => reducer.userProfile);
  const returnNull = <></>;
  function partnerIsLoggedLabel() {
    if (profileState.nivel !== 2) {
      return returnNull;
    }
    return <TableComponent.Label>Parceiro</TableComponent.Label>;
  }

  function partnerIsLoggedColumn(props: number) {
    if (profileState.nivel !== 2) {
      return returnNull;
    }

    const TableComponentConst = (
      <TableComponent.Data>
        {setPartner(props, partnerListState)}
      </TableComponent.Data>
    );

    return TableComponentConst;
  }

  function noValueColoumnText(e: number) {
    if (e === 0) {
      return returnNull;
    }
    return <TableComponent.Label>Saldo</TableComponent.Label>;
  }
  function noValueColoumn(e: number, y: number) {
    if (e === 0) {
      return returnNull;
    }
    const TableComponentConst = (
      <TableComponent.Balance value={e}>
        {y.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}
      </TableComponent.Balance>
    );

    return TableComponentConst;
  }
  // If partner logged don't show partner column: end

  // Modal: start
  const [bankInfoModalShow, setBankInfoModalShow] = React.useState(false);
  const [dataBankInfoModalShow, setDataBankInfoModalShow] = React.useState(
    clientsDataState.clients[0]
  );

  function setBankInfoModal(props) {
    setDataBankInfoModalShow(props);
    setBankInfoModalShow(true);
  }

  // Modal: end

  // Pagination: start
  const [data, setData] = useState(clientsDataState.clients);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  function paginate(pageNumber: number) {
    setCurrentPage(pageNumber);
  }
  function setItensPerPage(event: any) {
    const { value } = event.currentTarget;
    setDataPerPage(value);
    setCurrentPage(1);
  }
  // Pagination: end

  // Search: start
  const [query, setQuery] = useState('');
  function search(rows: any) {
    return rows.filter(
      (row: IClientsData) =>
        row.cpfCnpj.indexOf(query) > -1 ||
        row.companyName.toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  }
  useEffect(() => {
    setData(search(clientsDataState.clients));
    setCurrentPage(1);
  }, [query]);
  // Search: end

  function transformNumber(el) {
    return parseFloat(el);
  }
  useEffect(() => {
    setData(clientsDataState.clients);
    setCurrentPage(1);
  }, [clientsDataState.clients]);
  return (
    <Frame.Default
      isActive={clientsState.gotSuccess && clientsState.isActive}
      backgroundColor="#ffffff"
      padding="1rem"
      margin="0"
      flexDirection="column">
      <Wrapper.SearchAndButtons>
        <Wrapper.Search>
          <Text.Label>Buscar:</Text.Label>
          <Form.Control
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Nome, CPF ou CNPJ"
          />
        </Wrapper.Search>
        <Wrapper.Buttons>
          {ExportPdf(
            clientsDataState.totalBalance,
            clientsDataState.clients,
            clientsState.date
          )}
          {ExportCsv(clientsState)}
        </Wrapper.Buttons>
      </Wrapper.SearchAndButtons>
      <Wrapper.TableComponents>
        <TableComponent.Frame>
          <TableComponent.HeaderRow>
            <TableComponent.Head>
              <TableComponent.Label>ID</TableComponent.Label>
              <TableComponent.Label>Nome</TableComponent.Label>
              <TableComponent.Label>CPF/CNPJ</TableComponent.Label>
              {partnerIsLoggedLabel()}
              <TableComponent.Label>Tipo de Conta</TableComponent.Label>
              <TableComponent.Label>Informações</TableComponent.Label>
              {noValueColoumnText(clientsDataState.totalBalance)}
            </TableComponent.Head>
          </TableComponent.HeaderRow>

          <TableComponent.Body>
            {currentData.map((client: IClientsData) => {
              return (
                <TableComponent.Row
                  key={client.id}
                  status={transformNumber(client.status)}
                  closedAccount={client.closedAccount}>
                  <TableComponent.Id>{client.id}</TableComponent.Id>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id="email">{client.companyName}</Tooltip>
                    }>
                    <TableComponent.Data>
                      {capitalize(client.companyName)}
                    </TableComponent.Data>
                  </OverlayTrigger>
                  <TableComponent.Data>
                    {cpfCnpjMask(client.cpfCnpj)}
                  </TableComponent.Data>
                  {partnerIsLoggedColumn(client.partnerId)}
                  <TableComponent.Data>
                    {defineAccountType(client.accountFormat)}
                  </TableComponent.Data>
                  <TableComponent.Data>
                    <Wrapper.Buttons
                      style={{
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <Button.Info onClick={() => setBankInfoModal(client)}>
                        <Info />
                      </Button.Info>
                    </Wrapper.Buttons>
                  </TableComponent.Data>
                  {noValueColoumn(
                    clientsDataState.totalBalance,
                    client.balance
                  )}
                </TableComponent.Row>
              );
            })}
          </TableComponent.Body>
        </TableComponent.Frame>
        <Subtitle />
        <Wrapper.Pagination>
          <Form.Control
            as="select"
            onChange={(event) => setItensPerPage(event)}
            style={{ marginRight: '1rem' }}>
            <option key={14} value={10}>
              10
            </option>
            <option key={13} value={25}>
              25
            </option>
            <option key={12} value={50}>
              50
            </option>
            <option key={11} value={clientsDataState.clients.length}>
              Todos
            </option>
          </Form.Control>
          <PaginationComponent
            dataPerPage={dataPerPage}
            totalData={data.length}
            currentPage={currentPage}
            paginate={(e) => paginate(e)}
          />
        </Wrapper.Pagination>

        <BankInfoModal
          show={bankInfoModalShow}
          onHide={() => setBankInfoModalShow(false)}
          data={dataBankInfoModalShow}
        />
      </Wrapper.TableComponents>
    </Frame.Default>
  );
}

export default ClientsTableList;
